import React, { FC } from 'react';
import { Props } from './types';
import { Container, ContentLoader } from './styles';

const Loader: FC<Props> = ({ opacity = 1 }) => {
  return (
    <Container>
      <ContentLoader
        viewBox="0 0 400 120"
        backgroundColor="#f1f1f1"
        $opacity={opacity}
      >
        <rect x="60" y="17" rx="4" ry="4" width="60" height="9" />
        <rect x="320" y="45" rx="5" ry="5" width="50" height="11" />
        <rect x="60" y="45" rx="5" ry="5" width="172" height="11" />
        <rect x="60" y="75" rx="5" ry="5" width="130" height="11" />
        <rect x="60" y="98" rx="5" ry="5" width="95" height="11" />
        <circle cx="35" cy="52" r="12" />
      </ContentLoader>
    </Container>
  );
};

export default Loader;
